import { Button } from "@/components/ui/button";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";

interface HeadingProps {
  isConfirming: boolean;
  disabled: boolean;
  onConfirm: () => void;
}

function Heading({ disabled, onConfirm, isConfirming }: HeadingProps) {
  const { t } = useTranslation();
  return (
    <div className="border-y bg-white">
      <div className="px-6 pb-4 pt-8 flex justify-between gap-4">
        <div className="flex flex-col gap-2">
          <div className="text-2xl font-bold">{t("assessment-check")}</div>
          <div>{t("hearing-check-message")}</div>
        </div>
        <Button
          disabled={disabled}
          isLoading={isConfirming}
          onClick={() => {
            onConfirm();
          }}
        >
          {t("confirm-and-autograde")}
        </Button>
      </div>
      <TabsList className="mx-6">
        <TabsTrigger value="categories">{t("categories")}</TabsTrigger>
        <TabsTrigger value="assessment info">
          {t("assessment-info")}
        </TabsTrigger>
      </TabsList>
    </div>
  );
}

export default Heading;
